import type { ReactNode } from 'react';
import { Collapse, Space } from 'antd';
import { useAggregationConfig } from '../../../hooks/SimViewer/useAggregationConfig';
import { MapMarkedIconButton } from '../../MapMarkedIconButton';

type Props = {
  icon: ReactNode;
  label: string;
  extra?: ReactNode;
};

const TripPathPanel = ({ icon, label, extra }: Props): ReactNode => {
  const { aggregationConfig, startAggregation, clearAggregation } =
    useAggregationConfig();

  const isActive =
    aggregationConfig?.target === 'trip_path' &&
    aggregationConfig?.type === 'arcs';

  return (
    <Collapse.Panel
      key="trip_path"
      header={
        <Space>
          {icon}
          {label}
          {extra}
        </Space>
      }
      extra={
        <MapMarkedIconButton
          active={isActive}
          onClick={() => {
            if (isActive) {
              clearAggregation();
            } else {
              startAggregation('trip_path', undefined, 'arcs');
            }
          }}
        />
      }
    />
  );
};

export { TripPathPanel };
